var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.5H17.5L21.5 8.5V20.5C21.5 21.6 20.6 22.5 19.5 22.5H5.5C4.39 22.5 3.5 21.6 3.5 20.5V6.5C3.5 5.4 4.39 4.5 5.5 4.5ZM19.5 20.5V9.33L16.67 6.5H5.5V20.5H19.5ZM12.5 14C11.67 14 11 14.67 11 15.5C11 16.33 11.67 17 12.5 17C13.33 17 14 16.33 14 15.5C14 14.67 13.33 14 12.5 14ZM16 8H7V10H16V8Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10980_24289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0C18.2429 0 16 2.24292 16 5C16 7.75708 18.2429 10 21 10C23.7571 10 26 7.75708 26 5C26 2.24292 23.7571 0 21 0ZM20.9621 6.42458C20.8008 6.58583 20.5887 6.66625 20.3758 6.66625C20.1629 6.66625 19.9488 6.585 19.7858 6.4225L18.6267 5.29917L19.2071 4.70042L20.3708 5.82833L22.7912 3.45292L23.3762 4.04667L20.9621 6.42458Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10980_24289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "currentColor",
    transform: "translate(16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.40475dd20bf47c0eb7f19fba0e12e091.svg";
export { ForwardRef as ReactComponent };